var reviewListPopup = {
    urlParams: null,
    tabType: null,
    reviewId: null,
    viewType: null,
    initialIndex: null,
    emotionExpanded: null,
    careshipLoaded: false,

    init: function() {
        this.urlParams = new URLSearchParams(window.location.search);
        this.tabType = this.urlParams.get('tabType');
        this.reviewId = this.urlParams.get('reviewId');
        this.viewType = this.urlParams.get('viewType');
        this.initialIndex = this.urlParams.get('initialIndex');
        this.emotionExpanded = this.urlParams.get('emotionExpanded');

        this.handlePopupInit();
    },

    handlePopupInit: function() {
        var self = this;

        // 케어십 탭으로 이동
        if (self.tabType === 'careship') {
            self.handleCareshipTab();
        }
        // 일반 탭에서 레이어 오픈
        else if (self.reviewId && self.viewType) {
            self.handleGeneralTab();
        }
    },

    handleCareshipTab: function() {
        var self = this;

        // AJAX 완료 대기
        $(document).on('ajaxComplete', function(event, xhr, settings) {
            if (!self.careshipLoaded && settings.url &&
                (settings.url.indexOf('reviewModuleCareshipPopup') !== -1 ||
                    settings.url.indexOf('reviewModuleCareshipV2') !== -1)) {
                self.careshipLoaded = true;

                // 감정 더보기 펼치기
                if (self.emotionExpanded === 'true') {
                    setTimeout(function() {
                        var moreBtn = $('.rv-emotion-more');
                        if (moreBtn.length > 0) {
                            moreBtn.trigger('click');
                        }
                    }, 1500);
                }

                // 레이어 오픈
                if (self.reviewId && self.viewType) {
                    setTimeout(function() {
                        self.openLayerAfterLoad();
                    }, 800);
                }
            }
        });

        // 케어십 탭 클릭
        self.clickCareshipTab();
    },

    handleGeneralTab: function() {
        var self = this;

        if (document.readyState === 'complete') {
            setTimeout(function() {
                self.openLayerAfterLoad();
            }, 300);
        } else {
            $(window).on('load', function() {
                setTimeout(function() {
                    self.openLayerAfterLoad();
                }, 300);
            });
        }
    },

    clickCareshipTab: function() {
        var clickTab = function() {
            var careshipTab = $('.rv-tab-chip[data-tab="careship"]');
            if (careshipTab.length > 0 && !careshipTab.hasClass('active')) {
                careshipTab.trigger('click');
            }
        };

        if (document.readyState === 'complete') {
            setTimeout(clickTab, 300);
        } else {
            $(window).on('load', function() {
                setTimeout(clickTab, 300);
            });
        }
    },

    openLayerAfterLoad: function() {
        var self = this;
        var targetElement = $('[data-review-id="' + self.reviewId + '"]');

        if (targetElement.length > 0) {
            self.prepareElementAndOpenLayer(targetElement);
        } else {
            self.retryFindElement();
        }
    },

    prepareElementAndOpenLayer: function(targetElement) {
        var self = this;

        // modelId 자동 설정
        if (!targetElement.data('model-id') && !targetElement.data('modelId')) {
            var pathMatch = window.location.pathname.match(/\/review\/([^\/]+)\//);
            if (pathMatch && pathMatch[1]) {
                targetElement.attr('data-model-id', pathMatch[1]);
            }
        }

        // careLineSeq 설정
        var urlCareLineSeq = self.urlParams.get('careLineSeq');
        if (urlCareLineSeq && !targetElement.data('care-line-seq')) {
            targetElement.attr('data-care-line-seq', urlCareLineSeq);
        }

        // viewType 강제 설정
        var elementViewType = targetElement.attr('data-view-type');
        if (!elementViewType || elementViewType === '') {
            if (self.viewType && self.viewType !== '') {
                targetElement.attr('data-view-type', self.viewType);
            }
        }

        // 레이어 오픈
        if (self.viewType === 'photoVideo' && self.initialIndex === '9') {
            reviewLayer.reviewPhotoVideoLayer(targetElement[0]);
        } else {
            reviewLayer.reviewLayer(targetElement[0]);
        }
    },

    retryFindElement: function() {
        var self = this;
        var retryCount = 0;
        var retryInterval = setInterval(function() {
            var targetElement = $('[data-review-id="' + self.reviewId + '"]');
            if (targetElement.length > 0) {
                clearInterval(retryInterval);
                self.prepareElementAndOpenLayer(targetElement);
            } else if (++retryCount >= 10) {
                clearInterval(retryInterval);
            }
        }, 200);
    }
};

$(function () {
    reviewListPopup.init();
});